<template>
  <component :is="baseComponent"
             :to="link.path ? link.path : '/'"
             :exact="linkExact"
             :class="{active: isActive, hidden: !isVisible}"
             tag="li">
    <a v-if="isMenu"
       data-toggle="collapse"
       href="javascript:void(0)"
       @click="collapseMenu">
      <i :class="'icon-menu icon-menu-' + link.icon"></i>
      <p>{{$t('pages.' + link.name)}}
        <b class="caret"></b>
      </p>
    </a>
    <div v-if="$slots.default || this.isMenu">
      <el-collapse-transition>
        <ul class="nav sub-nav" v-show="!collapsed">
          <slot></slot>
        </ul>
      </el-collapse-transition>
    </div>
    <!-- link.name added by dev -->
    <slot name="title" v-if="children.length === 0 && !$slots.default && link.path && link.name">
      <component
        :to="loc ? link.path + '?location=' + loc : link.path"
        :is="elementType(link, false)"
        :class="{active: link.active, hidden: childIsHidden}"
        :exact="linkExact"
        :target="link.target"
        :href="loc ? '/#' + link.path + '?location=' + loc : '/#' + link.path"
        >
        <template v-if="addLink">
          <span class="sidebar-mini">{{link.nameshort ? link.nameshort : link.name.substring(0, 1)}}</span>
          <span class="sidebar-normal">{{$t('pages.' + link.name)}}</span>
        </template>
        <template v-else>
          <i :class="'icon-menu icon-menu-' + link.icon"></i>
          <p>{{$t('pages.' + link.name)}}</p>
        </template>
      </component>
    </slot>
  </component>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    props: {
      loc: String,
      menu: {
        type: Boolean,
        default: false
      },
      link: {
        type: Object,
        default: () => {
          return {
            name: '',
            path: '',
            hide_for_users: false,
            hide_for_admin_location: false,
            children: []
          }
        }
      }
    },
    provide () {
      return {
        addLink: this.addChild,
        removeLink: this.removeChild
      }
    },
    inject: {
      addLink: {default: null},
      removeLink: {default: null}
    },
    data () {
      return {
        children: [],
        collapsed: true
      }
    },
    computed: {
      baseComponent () {
        return this.isMenu || this.link.isRoute ? 'li' : 'router-link'
      },
      isMenu () {
        return this.children.length > 0 || this.menu === true
      },
      linkExact () {
        return this.link.exact === true
      },
      isActive () {
        if (!this.$route) {
          return false
        }

        const currentPath = this.$route.path
        const candidatePaths = []

        if (Array.isArray(this.link.activePaths) && this.link.activePaths.length) {
          candidatePaths.push(...this.link.activePaths)
        } else if (this.link.path) {
          candidatePaths.push(this.link.path)
        }

        const matchesPath = (candidate) => {
          if (!candidate) {
            return false
          }

          if (typeof candidate === 'string') {
            return currentPath === candidate || currentPath.startsWith(candidate + '/')
          }

          if (typeof candidate === 'object') {
            const path = candidate.path || ''
            if (!path) {
              return false
            }
            if (candidate.exact) {
              return currentPath === path
            }
            if (candidate.match === 'exact') {
              return currentPath === path
            }
            if (candidate.match === 'prefix-only') {
              return currentPath.startsWith(path)
            }
            return currentPath === path || currentPath.startsWith(path + '/')
          }

          return false
        }

        if (candidatePaths.some(matchesPath)) {
          return true
        }

        if (this.link.includeChildrenInActive !== false) {
          const matchingRoute = this.children
            .find((c) => c.link && typeof c.link.path === 'string' && currentPath.startsWith(c.link.path))

          if (matchingRoute !== undefined) {
            return true
          }
        }

        return false
      },
      childIsHidden () {
        var showToMenu = true
        if (
            this.link.hide_for_admin_location &&
            (this.$session.get('userDataRole') === 'LOCATION_ADMIN' ||
            this.$session.get('userDataRole') === 'LOCATION_STORE_ADMIN')
        ) {
          showToMenu = false
        }
        if (
          showToMenu &&
          this.link.hide_for_users &&
          this.$session.get('userDataRole') === 'USER'
        ) {
          showToMenu = false
        }
        if (this.link.companyToShow && showToMenu) {
          if (this.link.companyToShow.includes(this.$session.get('selectedCompany'))) {
            showToMenu = false
          }
        }
        if (this.link.name === 'dispatch' && !this.$session.get('selectedCompanyData').use_dispatch) {
          showToMenu = false
        }
        if (this.link.name === 'gestiune' && (!this.$session.get('selectedCompanyData').use_gestiune || !this.userHasRight('GESTIUNE'))) {
          showToMenu = false
        }
        return !showToMenu
      },
      isVisible () {
        if (!this.isFeatureEnabled(this.link)) {
          return false
        }
        if (this.$session.get('userDataRole') === 'USER_CUSTOM' && !this.userHasRight(this.link.custom_permission)) {
          return false
        }
        if (this.link.hide_bills && !JSON.parse(this.$session.get('userData')).is_allowed_to_see_bills) {
          return false
        }
        if (this.link.hide_for_marketer && this.$session.get('userDataRole') === 'MARKETER') {
          return false
        }
        if (this.link.hide_for_operator && this.$session.get('userDataRole') === 'OPERATOR') {
          return false
        }
        if (this.link.hide_for_admin_location && (this.$session.get('userDataRole') === 'LOCATION_ADMIN' || this.$session.get('userDataRole') === 'LOCATION_STORE_ADMIN')) {
          return false
        } else {
          return !this.link.hide_for_users || (this.link.hide_for_users && !(this.$session.get('userDataRole') === 'USER' && JSON.parse(this.$session.get('userDataLocations')).length >= 0))
        }
      }
    },
    methods: {
      addChild (item) {
        const index = this.$slots.default.indexOf(item.$vnode)
        this.children.splice(index, 0, item)
      },
      removeChild (item) {
        const tabs = this.children
        const index = tabs.indexOf(item)
        tabs.splice(index, 1)
      },
      isFeatureEnabled (link) {
        const userData = JSON.parse(this.$session.get('userData') || '{}')
        const company = (userData && userData.companies && userData.companies[0]) || {}

        const featureMap = {
          dispatch: 'use_dispatch',
          kds: 'use_kds',
          tables: 'use_table',
          reservations: 'use_table',
          pos: 'use_pos',
          screens: 'use_screens',
          marketing: ['use_marketing_standard', 'use_marketing_gift_card'],
          kiosk: 'use_kiosk',
          gestiune: 'use_gestiune',
          qr: 'use_qr_ordering'
        }

        if (link.name === 'online') {
          const hasApp = Number(company.use_app) === 1
          const hasWebsite = Number(company.use_website) === 1
          return hasApp || hasWebsite
        }

        const key = featureMap[link.name]

        if (!key) return true

        // ✅ special case for marketing (array)
        if (Array.isArray(key)) {
          return key.some(k => Number(company[k]) === 1)
        }

        return Number(company[key]) === 1
      },
      elementType (link, isParent = true) {
        if (link.isRoute === false) {
          return isParent ? 'li' : 'a'
        } else {
          return 'router-link'
        }
      },
      linkAbbreviation (name) {
        const matches = name.match(/\b(\w)/g)
        return matches.join('')
      },
      collapseMenu () {
        this.collapsed = !this.collapsed
      },
      collapseSubMenu (link) {
        link.collapsed = !link.collapsed
      }
    },
    mounted () {
      if (this.addLink) {
        this.addLink(this)
      }
      if (this.link.collapsed !== undefined) {
        this.collapsed = this.link.collapsed
      }
      if (this.isActive && this.isMenu) {
        this.collapsed = false
      }
    },
    destroyed () {
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el)
      }
      if (this.removeLink) {
        this.removeLink(this)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SidebarItem.vue